module.exports = __webpack_public_path__ + "img/row-srp-preview-hyundai.0bc2ed58.png";